import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const CATEGORIES = ['Hair Products', 'Skincare', 'Nail Products', 'Fragrances', 'Makeup', 'Equipment'];

function AddVendorPage() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    category: 'Hair Products',
    contact: '',
    phone: '',
    address: '',
    notes: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    await new Promise((r) => setTimeout(r, 500));
    setLoading(false);
    // TODO: Replace with actual API call
    navigate('/vendors');
  };

  return (
    <div className="max-w-2xl">
      <div className="mb-6">
        <Link
          to="/vendors"
          className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-800 text-sm font-medium"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
          </svg>
          Back to Vendors
        </Link>
      </div>

      <div className="card-premium overflow-hidden">
        <div className="px-6 py-5 border-b border-slate-100">
          <h1 className="font-display font-bold text-2xl text-slate-800 tracking-tight">Add New Vendor</h1>
          <p className="mt-1 text-slate-500">Register a new product supplier or vendor</p>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-5">
          <div>
            <label htmlFor="name" className="block text-sm font-medium text-slate-700 mb-1.5">
              Vendor Name <span className="text-red-500">*</span>
            </label>
            <input
              id="name"
              name="name"
              type="text"
              value={formData.name}
              onChange={handleChange}
              placeholder="e.g., Pro Beauty Supply Co"
              className="input-premium"
              required
            />
          </div>

          <div>
            <label htmlFor="category" className="block text-sm font-medium text-slate-700 mb-1.5">
              Category
            </label>
            <select
              id="category"
              name="category"
              value={formData.category}
              onChange={handleChange}
              className="input-premium"
            >
              {CATEGORIES.map((cat) => (
                <option key={cat} value={cat}>{cat}</option>
              ))}
            </select>
          </div>

          <div>
            <label htmlFor="contact" className="block text-sm font-medium text-slate-700 mb-1.5">
              Contact Email <span className="text-red-500">*</span>
            </label>
            <input
              id="contact"
              name="contact"
              type="email"
              value={formData.contact}
              onChange={handleChange}
              placeholder="e.g., vendor@example.com"
              className="input-premium"
              required
            />
          </div>

          <div>
            <label htmlFor="phone" className="block text-sm font-medium text-slate-700 mb-1.5">
              Phone
            </label>
            <input
              id="phone"
              name="phone"
              type="tel"
              value={formData.phone}
              onChange={handleChange}
              placeholder="e.g., +1 234 567 8900"
              className="input-premium"
            />
          </div>

          <div>
            <label htmlFor="address" className="block text-sm font-medium text-slate-700 mb-1.5">
              Address
            </label>
            <textarea
              id="address"
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="Street, city, state, zip"
              rows="2"
              className="input-premium resize-none"
            />
          </div>

          <div>
            <label htmlFor="notes" className="block text-sm font-medium text-slate-700 mb-1.5">
              Notes
            </label>
            <textarea
              id="notes"
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              placeholder="Any additional notes about this vendor"
              rows="3"
              className="input-premium resize-none"
            />
          </div>

          <div className="flex gap-3 pt-4">
            <button
              type="submit"
              disabled={loading}
              className="btn-primary"
            >
              {loading ? 'Adding...' : 'Add Vendor'}
            </button>
            <Link
              to="/vendors"
              className="px-6 py-2.5 border border-slate-200 text-slate-700 font-medium rounded-premium hover:bg-slate-50 transition-all"
            >
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default AddVendorPage;
